import { Component, OnInit } from '@angular/core';
import { AuthService } from 'pg-lib/services/auth.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { PersistenceService } from 'pg-lib/services/persistence.service';

@Component({
    selector: 'app-totem-profile',
    templateUrl: './totem-profile.component.html',
    styleUrls: ['./totem-profile.component.scss'],
    standalone: false
})
export class TotemProfileComponent implements OnInit {

    constructor(private localizationService:LocalizationService, private authService:AuthService, private persistenceService:PersistenceService) { }

    privacyPolicyURL:string = null;
    termsAndConditionsURL:string = null;

    ngOnInit(): void {
        this.privacyPolicyURL = this.localizationService.getPrivacyPolicyURL()
        this.termsAndConditionsURL = this.localizationService.getTermsAndConditionsURL();
    }

    get userName() {
        let _user = this.authService.user;
        if(_user == null) return null;
        let _parts = [_user.name, _user.surname].filter(Boolean);
        return _parts.length ? _parts.join(' ') : (_user.email || null);
    }

    get userEmail() {
        return this.authService.user?.email || null;
    }

    isCookieConsentAvailable() {
        return this.persistenceService.isConsentAvailable();
    }

    reviewCookies() {
        this.persistenceService.requestConsentReview();
    }
}
